import React, { useState } from "react";
import DataTable from "../../UI/table/DataTable";
import TableActions from "../../UI/table/TableActions";
import StarRatings from "../../technicalSupport/reviews/reviewsCard/starRatings";
import { useQuery } from "react-query";
import { getReviews } from "../../../MyApi/reviews";
import { useMutation, useQueryClient } from "react-query";
import { deleteReviews } from "../../../MyApi/reviews";

const ReviewsInfo = ({ id }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    search: "",
    status: "",
    date: "",
  });
  
  const queryClient = useQueryClient();
  const deleteMutation = useMutation({
    mutationKey: ["deleteReview"],
    mutationFn: (reviewId) => deleteReviews(reviewId),
    onSuccess: () => {
      queryClient.invalidateQueries(["getReviews", id]);
    },
  });

  const { data, isLoading, refetch, isFetching, error } = useQuery(
    ["getReviews", id, currentPage, filters],
    () => getReviews(currentPage, filters, null, id), // Pass store_id as 4th parameter
    {
      keepPreviousData: true,
    }
  );

  const reviews = data?.data?.reviews || [];
  const totalItems = data?.data?.pagination?.total || 0;
  const lastPage = data?.data?.pagination?.last_page || 0;

  const handleDelete = (reviewId) => {
    deleteMutation.mutate(reviewId);
  };

  const reviewsColumns = [
    {
      label: "المعرف",
      accessor: "id",
    },
    {
      label: "العميل",
      accessor: "user.name",
    },
    {
      label: "التعليق",
      accessor: "comment",
    },
    {
      label: "التقييم",
      render: (row) => (
        <div className="d-flex align-items-center">
          <StarRatings rating={row.rating} />
          <span className="ms-2">{row.rating}</span>
        </div>
      ),
    },
    {
      label: "التاريخ",
      accessor: "created_at",
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          deleteAction={() => handleDelete(row.id)}
          deletePermission={"delete_review"}
        />
      ),
    },
  ];

  const filtersConfig = {
    search: "search",
    reviewStatus: "status",
    date: "date",
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1); // Reset to first page when filters change
  };

  return (
    <div>
      <DataTable
        title={"تقييمات المتجر"}
        columns={reviewsColumns}
        data={reviews}
        isLoading={isLoading}
        isFetching={isFetching}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalItems={totalItems}
        itemsPerPage={lastPage}
        error={error}
        onRetry={() => refetch()}
      />
    </div>
  );
};

export default ReviewsInfo;